import React, { useState } from 'react';
import UISectionWrapper, {
  UISectionHeader,
  UISectionBody,
} from '@/components/shared/UISectionWrapper';
import UISectionTitle from '@/components/shared/UISectionTitle';
import UIIconExtraButton from '@/components/shared/UIIconExtraButton';
import PaymentCalendarTable from '../PaymentCalendarTable';
import './PaymentCalendarSection.scss';

export interface PaymentCalendarData {
  id: string;
  date: string;
  payment: {
    status: 'PENDING' | 'PAID' | 'DEBT' | 'WARNING';
  };
  tenant: {
    name: string;
    email: string;
    avatar?: string;
  };
  rent: {
    amount: number;
    currency: string;
  };
  unit: string;
  property: {
    name: string;
    type?: 'residential' | 'commercial' | 'mixed';
  };
}

interface PaymentCalendarSectionProps {
  data?: PaymentCalendarData[];
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
  onRowAction?: (id: string, action: string) => void;
}

// Мок-дані
const mockData: PaymentCalendarData[] = [
  {
    id: '1',
    date: '2024-10-24',
    payment: { status: 'PENDING' },
    tenant: { name: 'Frank Mitchell', email: 'frank@example.com' },
    rent: { amount: 1600, currency: '$' },
    unit: '203',
    property: { name: 'Arbre Magique', type: 'residential' }
  },
  {
    id: '2',
    date: '2024-10-01',
    payment: { status: 'PAID' },
    tenant: { name: 'Woo Chang', email: 'chang@example.com' },
    rent: { amount: 1850, currency: '$' },
    unit: '204',
    property: { name: 'Arbre Magique', type: 'residential' }
  },
  {
    id: '3',
    date: '2024-10-01',
    payment: { status: 'PAID' },
    tenant: { name: 'Amanda Stevenson', email: 'donec@example.com' },
    rent: { amount: 1500, currency: '$' },
    unit: '205',
    property: { name: 'Arbre Magique', type: 'residential' }
  },
  {
    id: '4',
    date: '2024-10-01',
    payment: { status: 'DEBT' },
    tenant: { name: 'Adam Patel', email: 'ipsum@example.com' },
    rent: { amount: 2100, currency: '$' },
    unit: '206',
    property: { name: 'Arbre Magique', type: 'residential' }
  },
  {
    id: '5',
    date: '2024-10-15',
    payment: { status: 'WARNING' },
    tenant: { name: 'Ron Chambers', email: 'ron@example.com' },
    rent: { amount: 3200, currency: '$' },
    unit: '207',
    property: { name: 'Arbre Magique', type: 'residential' }
  }
];

const mockHandlers = {
  onToggleCollapse: () => console.log('Toggle payment calendar collapse'),
  onRowAction: (id: string, action: string) => console.log('Row action:', id, action)
};

const PaymentCalendarSection: React.FC<PaymentCalendarSectionProps> = ({
                                                                         data = mockData,
                                                                         isCollapsed = false,
                                                                         onToggleCollapse = mockHandlers.onToggleCollapse,
                                                                         onRowAction = mockHandlers.onRowAction
                                                                       }) => {
  const baseClass = 'PaymentCalendarSection';

  const headerAction = (
    <UIIconExtraButton
      icon={isCollapsed ? 'expand' : 'collapse'}
      onClick={onToggleCollapse}
      ariaLabel={isCollapsed ? 'Expand calendar' : 'Collapse calendar'}
    />
  );

  return (
    <UISectionWrapper
      className={baseClass}
      align="stretch"
    >
      <UISectionHeader>
        <UISectionTitle
          title="Payment calendar"
          action={headerAction}
          showDivider={true}
        />
      </UISectionHeader>

      {!isCollapsed && (
        <UISectionBody>
          <div className={`${baseClass}__content`}>
            <PaymentCalendarTable
              data={data}
              onRowAction={onRowAction}
            />
          </div>
        </UISectionBody>
      )}
    </UISectionWrapper>
  );
};

export default PaymentCalendarSection;